// modules/i18n-it.js
// Toutes les chaînes italiennes centralisées

export const i18n = {

  // clip-manager.js
  clipDefaultName:     'Clip Audio',
  renamePrompt:        'Inserite un nuovo nome per il vostro clip audio',
  splitError:          'Errore durante il taglio dell\'audio',

  // clip-manager.js — boutons créés dynamiquement
  btnDelete:           'Elimina',
  btnDownload:         'Scarica',
  btnMoveUp:           '↑',
  btnMoveDown:         '↓',
  btnSplit:            'Taglia qui',

  // clip-manager.js — downloadAllClips
  noClipsToDownload:   'Nessuna registrazione da scaricare.',
  downloadSuccess:     (n) => `${n} file scaricato/i con successo!`,
  downloadError:       'Errore durante il download di alcuni file.',

  // import-manager.js — boutons
  btnImportFromPC:     'Importa dal computer',
  btnImportFromLib:    'Seleziona dalla libreria',

  // import-manager.js — bibliothèque modale
  libraryTitle:        'Libreria di suoni',
  librarySourceAll:    'Libreria completa',
  librarySourceCat:    (cat) => `Categoria: ${cat}`,
  libraryLoading:      'Caricamento dei suoni...',
  libraryEmpty:        'Nessun suono trovato in questa categoria.',
  libraryError:        'Impossibile caricare la libreria di suoni.',
  libraryListening:    (name, src) => `In ascolto: ${name} (${src})`,
  libraryClose:        'Chiudi',
  categoryAll:         'Tutti i suoni',
  categoryGenerique:   'Generici',
  categoryJingle:      'Jingle',
  categoryVirgule:     'Virgole',
  categoryDivers:      'Suoni vari',

  // project-manager-ui.js — modale
  projectTitle:        'Gestione dei progetti',
  projectIntro:        'Questa sezione permette di salvare i vostri progetti nella memoria del browser. Potrete poi caricarli o scaricarli facilmente.',
  projectSaveTitle:    'Salva questo progetto',
  projectNamePH:       'Nome del progetto',
  projectSaveBtn:      '💾 Salva',
  projectListTitle:    'Progetti salvati',
  projectClose:        'Chiudi',
  projectLoading:      'Caricamento dei progetti...',
  projectNone:         'Nessun progetto salvato',
  projectLoadError:    'Errore durante il caricamento dei progetti',
  projectSaving:       'Salvataggio in corso...',
  noProjectName:       'Inserite un nome per il progetto',
  noClipsToSave:       'Nessun clip audio da salvare',
  advancedActions:     'Azioni avanzate',
  btnClearAll:         '🗑️ Elimina tutto',
  btnExportAll:        '📦 Esporta tutto (ZIP)',
  exportPreparing:     'Preparazione...',
  exportInProgress:    (cur, tot, pct) => `Esportazione in corso... ${cur}/${tot} file (${pct}%)`,

  // project-manager-ui.js — actions sur un projet
  projectLoad:         '⬇️ Carica',
  projectLoadTitle:    'Carica questo progetto',
  projectZip:          '📦 ZIP',
  projectZipTitle:     'Scarica in ZIP',
  projectDelete:       '🗑️',
  projectDeleteTitle:  'Elimina questo progetto',

  // project-manager-ui.js — confirms & alerts
  confirmLoad:         'Caricare questo progetto sostituirà tutti i clip audio attuali. Continuare?',
  confirmDelete:       (name) => `Siete sicuri di voler eliminare "${name}"?`,
  confirmClearAll1:    '⚠️ ATTENZIONE: Questo eliminerà TUTTI i progetti salvati. Questa azione è irreversibile. Continuare?',
  confirmClearAll2:    'Siete davvero sicuri? Tutti i progetti andranno persi!',
  confirmExportAll:    (files, projects) => `Verrà creato un file ZIP contenente ${files} file audio di ${projects} progetto/i. Continuare?`,
  errorLoad:           (msg) => `Errore durante il caricamento del progetto: ${msg}`,
  errorExport:         (msg) => `Errore durante l'esportazione: ${msg}`,
  errorDelete:         (msg) => `Errore durante l'eliminazione: ${msg}`,
  errorClear:          (msg) => `Errore durante l'eliminazione: ${msg}`,
  successClear:        'Tutti i progetti sono stati eliminati',
  noProjectsToExport:  'Nessun progetto da esportare',
  exportSuccess:       '✓ Esportazione riuscita!',
};